<template>
  <BubbleMenu
    v-if="editor"
    class="bubble-menu"
    :editor="editor"
    v-show="!isModalShown"
  >
    <slot />
  </BubbleMenu>
</template>

<script setup lang="ts">
import { inject } from 'vue'
import { BubbleMenu, Editor } from '@tiptap/vue-3'

// Inject the provided editor instance, adjust the type if desired
const editor: Editor | undefined = inject('editor')

// Inject the provided richTextModal. Adjust the type, if desired.
const richTextModal = inject('richTextModal') as {
  value: { isModalShown: boolean }
}
const isModalShown = richTextModal.value?.isModalShown
</script>

<style lang="scss" scoped>
.bubble-menu {
  background: #fff;
  border-radius: $border-radius-base;
  border: 1px solid #ccc;
}
</style>
